import React from 'react';
import { Formik, Form, useField } from 'formik';
import * as Yup from 'yup';
import Button from '../Button';
import Upload from '../Upload';

import './form.css';

const TextInput = ({ label, keyID, installHelp, ...props }) => {
  const [field, meta] = useField(props);
  return (
    <div className={`input-field ${meta.touched && meta.error ? 'error' : ''}`} key={keyID}>
      <label htmlFor={props.id || props.name}>{label}</label>
      <input {...field} {...props} />
      {meta.touched && meta.error ? <div className="cl-error">{meta.error}</div> : null}
      {installHelp ? <a href={installHelp.url} target='_blank' className="cl-help">{installHelp.text}</a> : null}
    </div>
  );
};

const SelectInput = ({ label, options, keyID, installHelp, ...props }) => {
  const [field, meta] = useField(props);
  return (
    <div className="input-field" key={keyID}>
      <label htmlFor={props.id || props.name}>{label}</label>
      <select {...field} {...props}>
        {options.map((option,i) => <option key={i}>{option}</option>)}
      </select>
      {meta.touched && meta.error ? <div className="cl-error">{meta.error}</div> : null}
      {installHelp ? <a href={installHelp.url} target='_blank' className="cl-help">{installHelp.text}</a> : null}
    </div>
  );
};

const CheckboxInput = ({ label, keyID, ...props }) => {
  const [field] = useField({ ...props, type: 'checkbox' });
  return (
    <div className='checkbox-field' key={keyID}>
      <label className="checkbox">
        <input type="checkbox" {...field} {...props} />
        {label}
      </label>
    </div>
  );
};

const getValidationSchema = (template) => {
  const types = Object.keys(template).reduce((initialValues,field) => {
    initialValues[field] = template[field].settingType === 'email' ? 
      Yup.string().email('Invalid email address').required('Required') : 
      Yup.string().required('Required')
    return initialValues;
  },{});
  return Yup.object(types);
}

const CLForm = ({ fields, onSubmit, app }) => {
  const { template, settings } = fields;
  return (
    <Formik
      initialValues={settings}
      validationSchema={getValidationSchema(template)}
      onSubmit={(values) => onSubmit(values)}
    >
      <Form className='form'>
        {Object.keys(template)
          .sort((a,b) => template[a].settingType > template[b].settingType ? 1 : template[a].settingType < template[b].settingType ? -1 : 0)
          .map((field,i) => {
            if(['text','email','number'].indexOf(template[field].settingType) > -1) return <TextInput label={template[field].display} name={field} type={template[field].settingType} installHelp={template[field].installHelp} placeholder={template[field].default} min={template[field].min} max={template[field].max} key={i}/>
            if(template[field].settingType === 'boolean') return <CheckboxInput label={template[field].display} name={field} key={i}/>
            if(template[field].settingType === 'options') return <SelectInput label={template[field].display} name={field} installHelp={template[field].installHelp} options={template[field].options} key={i}/>
        })}
        <div className="buttons">
          <Button styling="apps-outlined" type="submit">Apply</Button>
          {app.csvUpload ? 
            <Upload 
              source={app.source} 
              buttonText="Upload Contacts CSV"
              multiple={false} 
              accept="text/csv"/> 
          : null}
        </div>
      </Form>
    </Formik>
  );
};

export default CLForm;


// WEBPACK FOOTER //
// ./src/components/CLForm/index.js